import script from "./BaseComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseComment.vue?vue&type=script&setup=true&lang=ts"

import "./BaseComment.vue?vue&type=style&index=0&id=701cf928&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701cf928"]])

export default __exports__